/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AccountLookup = {
    properties: {
        operatorId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        districtIds: {
            type: 'array',
            contains: {
                type: 'string',
                format: 'uuid',
            },
            isNullable: true,
        },
        name: {
            type: 'string',
            isNullable: true,
        },
        serviceAddress: {
            type: 'string',
            isNullable: true,
        },
        accountNumber: {
            type: 'string',
            isNullable: true,
        },
        serviceStatus: {
            type: 'ServiceStatusEnum',
        },
    },
};